
jQuery(document).ready(function(){
	jQuery("input[value='Register']").attr('value', 'Submit');
	jQuery("input[value='Get New Password']").attr('value', 'Submit'); 

	jQuery(".login-action-login p#nav a").first().html("Create an Account");
	jQuery(".login-action-lostpassword p#nav a").last().html("Create An Account");

	jQuery(".login-action-register .message.register").html('Create an Account');

	jQuery("#reg_passmail").html('After submission, you’ll be sent a link to create your password.');

	jQuery(".login label[for='user_login']").html(jQuery(".login label[for='user_login']").html().replace('Username or Email Address', 'Email Address') );
	jQuery(".login .message").html(jQuery(".login .message").html().replace('username or email address', 'email address') );

	jQuery(".login .message").html(jQuery(".login .message").html().replace('Registration complete. Please check your email.', 'Please check your email to complete your account setup.') );

	jQuery(".login-action-lostpassword #nav a").eq(1).html("Create an account");

	jQuery("#registerform #user_login").parent().hide();
	jQuery(document).on('keyup', "#user_email", function(){
		jQuery("#user_login").val(jQuery(this).val() );
	});

	// jQuery('.reset-pass a').each()
	
});